import React from "react";
import { Route, Switch } from "react-router";
import Bypassuser from "./pages/Bridge/Bypassuser";
import Login from "./pages/Bridge/Login";
import PayAborted from "./pages/Bridge/PayAborted";
import PayFail from "./pages/Bridge/PayFail";
import PayRed from "./pages/Bridge/PayRed";
import StartExam from "./pages/Learner/LearnerQuiz/StartExam";
import StartQuiz from "./pages/Learner/LearnerQuiz/startQuiz";
import Payment from "./pages/payment/Payment";
const Customroutes = () => {
    return (
        <div>
        <Route exact path="/Payment/:pathname" component={Payment} />
        <Route exact path="/startTest" component={StartQuiz} />
        <Route exact path="/StartExam" component={StartExam} />
        <Route exact path="/Eduplusnow/user" component={Login} />
        <Route exact path="/Eduplusnow/bypassuser" component={Bypassuser} />
        <Route exact path="/Eduplusnow/pay-red" component={PayRed} />
        <Route exact path="/Eduplusnow/pay-failed" component={PayFail} />
        <Route exact path="/Eduplusnow/pay-aborted" component={PayAborted} />
        </div>
    );
};

export default Customroutes;